import api from "api/api";
import { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useModalStore from "zustand/zustandstore";

const TemplateUpdate = ({ ismodal, setismodal, cards,user, selectedTemplate, defTemplatePrompt, fetchBasicData, setSeverity, setOpen, setAlertMessage  }) => {
  const [templateName, setTemplateName] = useState("");
const[savedtemplatename,setSavedTemplatename]=useState('')
  const [prompt, setPrompt] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
  const[savedprompt,setSavedPrompt]=useState('')
const [loading,setLoading]=useState(false)
const mydata=useModalStore()
      const specialTemplates = ['soap_note', 'HnP', 'soap_note_combined'];
  // Update state when selectedTemplate changes
  useEffect(() => {
    const templateData = cards.find((card) => Object.keys(card)[0] === selectedTemplate);
    if (templateData) {
   
      // const templateKey = Object.keys(templateData)[0];
      // setTemplateName(templateKey);
      // setSavedTemplatename(templateKey)

      if (specialTemplates.includes(selectedTemplate)) {
      console.log(defTemplatePrompt,'def')
        const matched = defTemplatePrompt.find(obj => obj.template === selectedTemplate);
        if (matched) {
 
          setTemplateName(matched.template);
          setSavedTemplatename(matched.template);
          setPrompt(matched.instructions);
          setSavedPrompt(matched.prompt);
        }else{
  
          const matched = cards.find(obj => Object.keys(obj)[0] === selectedTemplate);

          setTemplateName(matched?.[selectedTemplate] ? selectedTemplate : '');
          setSavedTemplatename(matched?.[selectedTemplate] ? selectedTemplate : '');
          setPrompt('');
          setSavedPrompt('');
        }
      } else {

        const templateData = cards.find((card) => Object.keys(card)[0] === selectedTemplate);
        if (templateData) {
  
          const templateKey = Object.keys(templateData)[0];
          setTemplateName(templateKey);
          setSavedTemplatename(templateKey);
          setPrompt(templateData[templateKey].instructions);
          setSavedPrompt(templateData[templateKey].prompt);
        }
      }
    
    }
  }, [selectedTemplate, cards]);
  const formatSection = (section) => {
    return section
      .toLowerCase()
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/^./, (char) => char.toUpperCase()); // Capitalize first letter
  };
  
  const sections = selectedTemplate ? Object.keys(cards?.find(obj => obj[selectedTemplate])?.[selectedTemplate] || {}) : [];

  if (!ismodal) return null;

  const handleSubmit = async () => {
    try {
        setLoading(true)
        if(templateName!==savedtemplatename){
const response =await api.put(`v1/user_templates/update_template_name`,{
  "new_name": templateName,
  "old_name": savedtemplatename
})


if(savedprompt==prompt){
  fetchBasicData()
  setTimeout(() => {
    window.location.reload();
setismodal(false)
}, 1500);
return
}

        }
       
        let obj={         
                "template_name": templateName,
               "user_instructions":prompt,
               'template_prompt':savedprompt
                }
                if(specialTemplates.includes(templateName)){
                  obj. default_template= true
                }
 setSavedPrompt(prompt)
if(mydata.usertype==='PRO'){

  const template = user.templates?.templates?.find(t => t.template === savedtemplatename);

  obj.section_name=selectedSection||template?.section_name
}

        const  savetemplate=await api.post('/v1/user_templates/save_template',obj)
            if(savetemplate.status===200){
              setSeverity('success')
          
              setAlertMessage('Successfully saved the template');
              setOpen(true);
              fetchBasicData()
              setTimeout(() => {
                window.location.reload();
      setismodal(false)
            }, 1500);
              
            }else{
              setSeverity('error')
            
              setAlertMessage('Something Went Wrong')
              setOpen(true);
            }
     
         } catch (error) {
        console.log(error)
        setSeverity('error')
            
        setAlertMessage('Something Went Wrong')
        setOpen(true);
    }finally{
      setSavedTemplatename(templateName)
setLoading(false)  

  
  };
  }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-[90%] sm:w-[55%] h-auto flex flex-col rounded-md shadow-lg p-6 space-y-4 relative">
        {/* Close Icon */}
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
          onClick={() => setismodal(false)}
        >
          <AiOutlineClose size={20} />
        </button>

        {/* Heading */}
        <h2 className="text-xl font-semibold text-[#1c2a3a] text-left">Update Template</h2>

        {/* Template Name Input */}
        <label className="text-gray-700 text-sm text-start font-medium">Template Name</label>
        <input
          type="text"
          value={templateName}
         onChange={(e)=>setTemplateName(e.target.value)}
          className="border p-2 rounded-md w-full bg-gray-100"
        />
  { mydata.usertype==='PRO'?<div className="flex flex-col">
          <label className="font-medium text-sm mb-2 text-start text-[#1c2a3a]">Select Section</label>
          <select
            className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-[#1c2a3a]"
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
            disabled={!selectedTemplate}
          >
            <option value="">Choose Section</option>
            {sections.map((section) => (
              <option key={section} value={section}>{formatSection(section)}</option>
            ))}
          </select>
        </div>
      :<></>  }
        {/* Prompt Text Area */}
        <label className="text-gray-700 text-sm text-start font-medium">Template Instruction</label>
        <textarea
          value={prompt}
          rows={8}
          onChange={(e) => setPrompt(e.target.value)}
          className="border p-2 rounded-md w-full "
        />

        {/* Buttons */}
        <div className="flex justify-end space-x-4">
          <button
            onClick={() => setismodal(false)}
            className="px-4 py-2 bg-gray-300 rounded-md text-sm font-medium hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 cursor-pointer bg-[#1C2A3A] text-white rounded-md text-sm font-medium hover:bg-blue-700"
          >
           
           {loading?"Updating":'update'}
                     </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateUpdate;
